/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lock': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(10 8)" _stroke="#00272E"><circle pid="0" cx="6.5" cy="10.625" r="1"/><path pid="1" d="M6.5 11.333v2.125"/><rect pid="2" x=".361" y="6.729" width="12.278" height="9.917" rx=".72"/><path pid="3" d="M2.528 4.25C2.528 2.098 4.306.354 6.5.354s3.972 1.744 3.972 3.896v2.48H2.528V4.25z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/lock.js